module.exports = __webpack_public_path__ + "media/images/uscc_logo-6495a499477f38142e6966523301a5dc.svg";